import { DialogBranch, DialogStep } from '@storyverseco/svs-dialog-ruleset';
import { DialogLike } from '../types';

/**
 * This migration got introduced because now backgrounds need to be defined in each step.
 */

export const migratePerStepBackgrounds = async (dialog: DialogLike): Promise<DialogLike> => {
  const branch = dialog.scenes.scene1.branches.start as DialogBranch;

  // Original background
  const parallax = branch.parallax;
  // Should never get here
  if (!parallax) {
    throw new Error(`Error: Could not find parallax data in 'branch'`);
  }

  const steps = branch.steps as DialogStep[];

  Object.values(branch.steps).forEach((step) => {
    if (!step.parallax) step.parallax = parallax;
  });

  branch.steps = steps;

  return dialog;
};
